import axios from "axios";

export interface IResponse {
    error_code: number;
    data?: any;
    error_message: string;
}

const api = axios.create({
    baseURL: process.env.REACT_APP_PM_API,
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
    },
    withCredentials: true,
  });
api.defaults.timeout = 30000;

export default api;
